import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null;
  
  return (
    <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
      <Loader2 className="w-16 h-16 text-orange-600 animate-spin" />
    </div>
  );
};

export default LoadingOverlay;